import React, { useState, useCallback, useEffect } from 'react';
import classnames from 'classnames';
import CryptoJSMD5 from 'crypto-js/md5';

//http://via.placeholder.com/1400x400
const ImagePicker = ({ onChange, value, className, avatar_url = null }) => {
  const [fileUrl, setFileUrl] = useState(avatar_url);

  const createFileUrl = useCallback(fileRef => {
    const reader = new FileReader();
    reader.readAsDataURL(fileRef);
    reader.onloadend = () => {
      const base64data = reader.result;

      setFileUrl(base64data);
    };
  }, []);

  const onFileChange = useCallback(
    e => {
      const event = e.nativeEvent;
      const file = event.target.files[0];

      onChange(file);
    },
    [onChange],
  );

  useEffect(() => {
    if (value) createFileUrl(value);
  }, [createFileUrl, value]);

  return (
    <div className={classnames('mb-6', className)} key="file-picker">
      <input
        type="file"
        multiple={false}
        className="border-brandblue border-solid border rounded-lg py-2 px-4 w-full text-lg"
        onChange={onFileChange}
      />

      {fileUrl && (
        <div
          className="mt-2 bg-contain bg-gray-800 pb-48 bg-center bg-no-repeat"
          style={{ backgroundImage: `url(${fileUrl})` }}
        />
      )}
    </div>
  );
};

export const getFileChecksum = file =>
  new Promise(resolve => {
    const reader = new FileReader();

    reader.onload = function(event) {
      const binary = event.target.result;
      const md5 = CryptoJSMD5(binary).toString();

      resolve(md5);
    };

    reader.readAsBinaryString(file);
  });

export default React.memo(ImagePicker);
